/**
 * @requires ./frc.js
 */

 frc.pages.home = {
 	"init": function(){
 		var self = frc.page = frc.pages.home;

 		var $findALocationField = $("[data-module-id=\"geo-search-combo\"] input[name=\"query\"]");

		if(frc.data.user.geolocation && frc.data.user.geolocation.description){
			$findALocationField.val(frc.data.user.geolocation.description);
		}
        $(frc).on("geolocationdescriptiondetermined", function(jqE, e){
        	if(e){
        		$findALocationField.val(e);
        	}
        });

        // Geolocate
        if(!frc.data.user.geolocation||!frc.data.user.geolocation.coordinates){
            frc.utilities.geolocate(function(){});
		}
		
		// Check cookie policy agreement status
		if (window.localStorage.getItem('cookie-policy') == "agree") {
			$('#cookie-policy-slideup').remove();
		} else {
			$('#cookie-policy-slideup').toggleClass('hidden', false);
			setTimeout(function () {
				$('#cookie-policy-slideup').animate({
					bottom: '0px'
				}, 700)
			}, 1000);
		}

		// Click action for user clicking "Agree"
		$("#cookie-policy-slideup #cookie-policy-accept").click(function() {
			window.localStorage.setItem('cookie-policy', 'agree');
			
			$('#cookie-policy-slideup').animate({
				bottom: '-300px'
			}, 250)

			setTimeout(function () {
				$('#cookie-policy-slideup').remove();
			}, 1000);

		});
	}
};